import {
  PageResponse,
  PageData,
  IntegrationCustomerSearchParams,
  IntegrationCustomerVo,
} from "@/types";
import { APIRequest } from "@/utils/api";

const IntegrationCustomerAPI = new APIRequest({
  baseURL: "/api/wms/v2/integration/customers",
});

export async function queryCustomers(
  params: IntegrationCustomerSearchParams,
): Promise<PageData<IntegrationCustomerVo>> {
  return IntegrationCustomerAPI.get<PageResponse<IntegrationCustomerVo>>({
    url: "",
    params,
  }).then((res) => res.data);
}
